/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Toast_Reingest_LoadingInputs */

const es_settings_files_toast_reingest_loading = /** @type {(inputs: Settings_Files_Toast_Reingest_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingestando archivo…`)
};

const en_settings_files_toast_reingest_loading = /** @type {(inputs: Settings_Files_Toast_Reingest_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingesting file…`)
};

/**
* | output |
* | --- |
* | "Re-ingesting file…" |
*
* @param {Settings_Files_Toast_Reingest_LoadingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_reingest_loading = /** @type {((inputs?: Settings_Files_Toast_Reingest_LoadingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Reingest_LoadingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_reingest_loading(inputs)
	return en_settings_files_toast_reingest_loading(inputs)
});
export { settings_files_toast_reingest_loading as "settings.files.toast.reingest_loading" }